<template>
  <div>
    <TaxrollTransactionList />
  </div>
</template>

<script>
import TaxrollTransactionList from '../../../components/tax/TaxInquiry/taxrollSearch/TaxrollTransactionList.vue';

export default {
  name: 'TaxrollSearch',
  data: () => ({}),
  components: {
    TaxrollTransactionList,
  },
};
</script>
